import { FC } from 'react'

import { LogoProps } from '@assets/logo/types'

export const TMUKLogo: FC<LogoProps> = ({ className }) => (
  <svg
    className={className}
    width='157'
    height='32'
    viewBox='0 0 157 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_6765_254)'>
      <path
        d='M17.4472 20.4698H12.3935C11.7795 20.4698 11.2128 20.1425 10.9064 19.6112L8.00207 14.5797C7.69557 14.0484 7.69557 13.3938 8.00207 12.8615L10.9064 7.83007C11.2128 7.29874 11.7805 6.97146 12.3935 6.97146H17.4452L21.4582 0.0167583C21.3724 0.0108436 21.2877 0 21.201 0H9.3936C8.14693 0 6.99389 0.665404 6.37007 1.74582L0.467869 11.9743C-0.155956 13.0547 -0.155956 14.3855 0.467869 15.4659L6.37105 25.6944C6.99488 26.7749 8.14693 27.4403 9.39459 27.4403H21.2019C21.2896 27.4403 21.3754 27.4294 21.4611 27.4235L17.4481 20.4708L17.4472 20.4698Z'
        fill='#FF0044'
      />
      <path
        d='M30.1277 11.9742L24.2245 1.74568C24.1811 1.66978 24.1289 1.60077 24.0796 1.52881L20.0667 8.48154L22.5945 12.8604C22.901 13.3917 22.901 14.0463 22.5945 14.5786L20.0686 18.9555L24.0816 25.9092C24.1299 25.8382 24.1821 25.7702 24.2255 25.6943L30.1287 15.4658C30.7525 14.3854 30.7525 13.0546 30.1287 11.9742H30.1277Z'
        fill='#28F981'
      />
      <path
        d='M45.3597 22.082H41.3969V7.88178H36.0545V4.52026H50.7267V7.88178H45.3597V22.082Z'
        fill='var(--text-white)'
      />
      <path d='M57.2991 22.082H53.3364V4.52026H57.2991V22.082Z' fill='var(--text-white)' />
      <path
        d='M69.613 22.3591C66.9698 22.3591 64.7761 21.4936 63.0278 19.7616C61.2815 18.0316 60.4083 15.8609 60.4083 13.2505C60.4083 10.7082 61.2982 8.57198 63.0781 6.84095C64.8589 5.10893 67.0871 4.24341 69.7637 4.24341C72.3724 4.24341 74.6794 5.22229 76.6859 7.17907L74.3789 10.0142C72.9745 8.47537 71.4529 7.70646 69.814 7.70646C68.3249 7.70646 67.0634 8.21217 66.0267 9.22457C64.9899 10.236 64.4716 11.5609 64.4716 13.2002C64.4716 13.9041 64.5819 14.5843 64.8037 15.2457C65.0244 15.9052 65.3595 16.4996 65.8069 17.0261C66.2543 17.5534 66.8131 17.9714 67.4813 18.2819C68.1505 18.5905 68.927 18.7453 69.814 18.7453C71.3859 18.7453 72.9075 18.0523 74.3789 16.6633L76.7106 19.1967C74.5208 21.3044 72.1546 22.3591 69.613 22.3591Z'
        fill='var(--text-white)'
      />
      <path
        d='M95.8236 22.082H91.0833L86.0168 14.8818L83.5087 17.6667V22.082H79.546V4.52026H83.5087V12.6983L90.7817 4.52026H95.3978L88.7752 11.821L95.8236 22.082Z'
        fill='var(--text-white)'
      />
      <path
        d='M118.196 22.082H114.634V10.2151L109.642 20.2997H107.084L102.068 10.2151V22.082H98.5061V4.52026H102.92L108.388 15.3087L113.805 4.52026H118.195L118.196 22.082Z'
        fill='var(--text-white)'
      />
      <path d='M126.523 22.082H122.56V4.52026H126.523V22.082Z' fill='var(--text-white)' />
      <path
        d='M142.373 22.082H130.887V4.52026H134.85V18.6199H142.373V22.082Z'
        fill='var(--text-white)'
      />
      <path
        d='M156.695 22.082H145.209V4.52026H149.172V18.6199H156.695V22.082Z'
        fill='var(--text-white)'
      />
      <path
        d='M82.4208 31.95C81.9685 31.95 81.5447 31.8662 81.1515 31.6967C80.7583 31.5281 80.438 31.256 80.1906 30.8794C79.96 30.5177 79.8447 30.0514 79.8447 29.4806V26.0974H81.1446V29.4806C81.1446 29.936 81.2717 30.2722 81.527 30.4891C81.7822 30.7059 82.0818 30.8144 82.4277 30.8144C82.7677 30.8144 83.0594 30.7079 83.3048 30.493C83.5483 30.2791 83.6705 29.942 83.6705 29.4806V26.0974H84.9703V29.4806C84.9703 30.0405 84.859 30.5029 84.6372 30.8676C84.3987 31.2491 84.0854 31.5251 83.6971 31.6947C83.3088 31.8642 82.883 31.95 82.4189 31.95H82.4208Z'
        fill='var(--text-white)'
      />
      <path
        d='M91.5142 31.8593H90.3286L87.5386 28.1557V31.8593H86.2959V26.0974H87.4815L90.2793 29.8178V26.0974H91.5142V31.8593Z'
        fill='var(--text-white)'
      />
      <path d='M94.237 31.8593H92.9371V26.0974H94.237V31.8593Z' fill='var(--text-white)' />
      <path
        d='M98.1545 31.8593H96.8546V27.2005H95.1024V26.0974H99.9166V27.2005H98.1555L98.1545 31.8593Z'
        fill='var(--text-white)'
      />
      <path
        d='M105.248 31.8593H100.771V26.0974H105.157V27.1759H102.072V28.4268H104.845V29.5053H102.072V30.7809H105.248V31.8593Z'
        fill='var(--text-white)'
      />
      <path
        d='M108.82 31.8593H106.425V26.0974H108.87C109.758 26.0974 110.485 26.3646 111.05 26.8998C111.614 27.4351 111.897 28.1281 111.897 28.9779C111.897 29.8227 111.613 30.5147 111.042 31.052C110.471 31.5892 109.731 31.8583 108.821 31.8583L108.82 31.8593ZM108.901 30.7651C109.108 30.7651 109.309 30.7316 109.506 30.6665C109.705 30.6005 109.884 30.497 110.045 30.354C110.204 30.2111 110.333 30.0277 110.428 29.803C110.525 29.5782 110.572 29.3061 110.572 28.9877C110.572 28.4396 110.402 28.0029 110.062 27.6796C109.721 27.3553 109.316 27.1936 108.844 27.1936H107.725V30.7661L108.901 30.7651Z'
        fill='var(--text-white)'
      />
      <path
        d='M120.874 31.8593H119.32L117.658 29.4974L116.835 30.4112V31.8603H115.535V26.0984H116.835V28.7817L119.222 26.0984H120.736L118.563 28.4938L120.875 31.8603L120.874 31.8593Z'
        fill='var(--text-white)'
      />
      <path d='M123.054 31.8593H121.754V26.0974H123.054V31.8593Z' fill='var(--text-white)' />
      <path
        d='M129.705 31.8593H128.519L125.729 28.1557V31.8593H124.486V26.0974H125.672L128.47 29.8178V26.0974H129.705V31.8593Z'
        fill='var(--text-white)'
      />
      <path
        d='M133.785 31.95C132.907 31.95 132.177 31.6681 131.593 31.1032C131.008 30.5394 130.716 29.8434 130.716 29.0153C130.716 28.1774 131.015 27.4815 131.616 26.9274C132.217 26.3734 132.965 26.0974 133.858 26.0974C134.72 26.0974 135.491 26.3774 136.17 26.9363L135.438 27.8659C134.944 27.4381 134.418 27.2242 133.858 27.2242C133.32 27.2242 132.886 27.3947 132.551 27.7368C132.216 28.0788 132.049 28.5047 132.049 29.0134C132.049 29.383 132.133 29.7024 132.299 29.9725C132.467 30.2416 132.689 30.4496 132.966 30.5946C133.243 30.7395 133.543 30.8114 133.867 30.8114C134.212 30.8114 134.588 30.7079 134.995 30.4999V29.5891H133.784V28.6013H136.121V31.1988C135.435 31.6976 134.657 31.947 133.784 31.947L133.785 31.95Z'
        fill='var(--text-white)'
      />
      <path
        d='M139.809 31.8593H137.414V26.0974H139.859C140.747 26.0974 141.474 26.3646 142.039 26.8998C142.604 27.4351 142.887 28.1281 142.887 28.9779C142.887 29.8227 142.602 30.5147 142.031 31.052C141.461 31.5892 140.72 31.8583 139.81 31.8583L139.809 31.8593ZM139.891 30.7651C140.098 30.7651 140.299 30.7316 140.496 30.6665C140.694 30.6005 140.873 30.497 141.034 30.354C141.193 30.2111 141.323 30.0277 141.417 29.803C141.514 29.5782 141.561 29.3061 141.561 28.9877C141.561 28.4396 141.392 28.0029 141.052 27.6796C140.711 27.3553 140.306 27.1936 139.833 27.1936H138.714V30.7661L139.891 30.7651Z'
        fill='var(--text-white)'
      />
      <path
        d='M146.433 31.9496C145.56 31.9496 144.827 31.6657 144.232 31.0979C143.637 30.5301 143.339 29.8203 143.339 28.9706C143.339 28.1208 143.634 27.4131 144.223 26.8512C144.813 26.2883 145.549 26.0073 146.433 26.0073C147.321 26.0073 148.06 26.2912 148.647 26.859C149.234 27.4269 149.527 28.1307 149.527 28.9706C149.527 29.8203 149.232 30.5301 148.643 31.0979C148.053 31.6657 147.316 31.9496 146.433 31.9496ZM146.449 30.814C146.66 30.814 146.869 30.7765 147.075 30.7006C147.282 30.6247 147.468 30.5114 147.637 30.3596C147.805 30.2068 147.94 30.0155 148.042 29.7829C148.143 29.5502 148.194 29.2801 148.194 28.9706C148.194 28.5812 148.112 28.252 147.947 27.9828C147.772 27.6999 147.552 27.4899 147.287 27.3509C147.022 27.2129 146.743 27.1429 146.449 27.1429C145.988 27.1429 145.577 27.3125 145.215 27.6526C144.854 27.9927 144.672 28.4324 144.672 28.9696C144.672 29.5128 144.851 29.9554 145.207 30.2984C145.564 30.6415 145.978 30.814 146.449 30.814Z'
        fill='var(--text-white)'
      />
      <path
        d='M156.998 31.8593H155.83V27.9655L154.192 31.2747H153.354L151.708 27.9655V31.8593H150.539V26.0974H151.988L153.782 29.6364L155.56 26.0974H157V31.8593H156.998Z'
        fill='var(--text-white)'
      />
    </g>
    <defs>
      <clipPath id='clip0_6765_254'>
        <rect width='157' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
